<template>
  <BreadCrumb PageTitle="Documents" />
  <VerificationDocs />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import VerificationDocs from "@/components/Generals/verificationDocs/VerificationDocs.vue";

export default defineComponent({
  name: "VerificationDocsPage",
  components: {
    BreadCrumb,
    VerificationDocs,
  },
});
</script>